"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSTS = void 0;
const CONSTS = exports.CONSTS = Object.freeze({
  // アクション名のプロジェクト共通接頭辞
  COMMON_ACTION_PREFIX: 'kansa',
  // 子画面表示時の共通key
  COMMON_SUB_WINDOW_KEY: 'kansa',
  /**
   * 処理分岐内容
   */
  PROC_KBN: {
    /** 簡易版かつ参照 */
    REFERENCE: '0',
    /** 詳細版かつ参照 */
    DETAIL_REFERENCE: '1',
    /** 登録・更新 */
    REGISTER_OR_UPDATE: '2'
  }
});